/* ---------------------------------------------------------------------------
 * MD Fashionwear — normalise the "Wear it with" prices
 *
 * Everywhere else the store now reads AMOUNT then ISO CODE, "6,262.92 ALL",
 * because snippets/price-list.liquid was changed to render it that way. The
 * "Wear it with" block on the product page does not use that snippet — it prints
 * its own price with Liquid's money filter, so it still said "Lek 6,262.92".
 *
 * That block lives inside sections/main-product.liquid, 62KB, and rewriting a
 * file that size to change one line is a poor trade. This corrects it in place.
 *
 * IT DOES NOT PARSE THE DISPLAYED TEXT. Reading "Lek 6,262.92" back into a number
 * means guessing which mark is the thousands separator, which differs by currency
 * and would eventually be wrong. Each card carries a product link and a
 * data-variant-id, so the real price in cents is fetched from
 * /products/{handle}.js and formatted with the same helper the rest of the store
 * uses. Correct or untouched, never guessed.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var cache = {};

  function fmt(cents) {
    if (window.MDCartSync && window.MDCartSync.fmt) return window.MDCartSync.fmt(cents);
    if (window.MDWishlist && window.MDWishlist.formatMoney) return window.MDWishlist.formatMoney(cents);

    var amount = (Number(cents) || 0) / 100;
    var n;
    try {
      n = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      n = amount.toFixed(2);
    }
    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return code ? n + ' ' + code : n;
  }

  function product(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function fixItem(item) {
    if (item.getAttribute('data-md-price') === '1') return;

    var priceEl = item.querySelector('.wear-it-with__price');
    if (!priceEl) return;

    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return;

    var handle = link.getAttribute('href').split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    var btn = item.querySelector('[data-variant-id]');
    var variantId = btn ? btn.getAttribute('data-variant-id') : null;

    item.setAttribute('data-md-price', '1');

    product(handle).then(function (p) {
      if (!p) { item.removeAttribute('data-md-price'); return; }

      var variants = p.variants || [];
      var v = null;

      if (variantId) {
        v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      }
      if (!v) v = variants.filter(function (x) { return x.available; })[0] || variants[0];
      if (!v) { item.removeAttribute('data-md-price'); return; }

      priceEl.textContent = fmt(v.price);
    });
  }

  function run() {
    var items = document.querySelectorAll('.wear-it-with__item');
    for (var i = 0; i < items.length; i++) fixItem(items[i]);
  }

  function boot() {
    run();

    var tries = 0;
    (function attempt() {
      if (document.querySelector('.wear-it-with__item')) { run(); return; }
      if (tries++ > 25) return;
      setTimeout(attempt, 200);
    })();

    // The block can be re-rendered when the variant changes.
    if (window.MutationObserver && document.body) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; run(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDPriceNormalize = { run: run, fmt: fmt };
})();
